import { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import emailjs from "emailjs-com";
import bgImage from "../assets/images/contacthero.jpeg";
import axios from 'axios';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactPage = () => {

  
const captchaRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.email || !formData.message) {
    toast.error('Please fill in all required fields');
    return;
  }

  setSubmitting(true);

  try {
    await emailjs.send(
      "service_wjpngv8",
      "template_j7nl6ia",
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        service: formData.service,
        message: formData.message,
      },
      "jSDaWIXQ5J1_7KYo5"
    );

    toast.success("Message sent successfully!");
    
    setFormData({
      name: '',
      email: '',
      company: '',
      phone: '',
      message: '',
      service: ''
    });

  } catch (error) {
    toast.error("Failed to send message");
  } finally {
    setSubmitting(false);
  }
};

  return (
    <div data-testid="contact-page" className="bg-gradient-to-b from-gray-50 to-white" style={{marginTop:"-80px"}}>
      {/* Hero Section */}
<section
  className="py-40 bg-cover bg-center relative"
  style={{ backgroundImage: `url(${bgImage})`,   backgroundPosition: "center 80%" }}
>

  <div className="relative max-w-6xl mx-auto px-6 text-center">
<motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
    {/* Heading */}
    <h1 className="text-4xl md:text-5xl font-semibold text-[#1f3d2b]">
      Contact Us
    </h1>
</motion.section>

<motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
    <p className="text-gray-600 mt-3 text-lg">
      We value your time. Let’s connect.
    </p>
</motion.section>
    {/* Divider */}
    {/* <div className="w-80 h-[1px] bg-gray-200 mx-auto mt-6"></div>  */}

    {/* Contact Columns */}
    {/* Contact Columns */}
<div className="mt-12 rounded-lg grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 divide-y sm:divide-y-0 md:divide-x divide-gray-200 shadow-[0_-4px_8px_rgba(0,0,0,0.05)]">

  {/* Call */}
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    className="flex items-start gap-4 p-8 text-left"
  >
    <FaPhoneAlt className="text-[#70c037] text-3xl mt-1" />
    <div>
      <h3 className="font-semibold text-gray-800">Call Us</h3>
      <p className="text-gray-600">+91 93463 99632</p>
    </div>
  </motion.div>

  {/* Email */}
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    className="flex items-start gap-4 p-8 text-left"
  >
    <FaEnvelope className="text-[#70c037] text-3xl mt-1" />
    <div>
      <h3 className="font-semibold text-gray-800">Email Us</h3>
      <p className="text-gray-600">sunoji@abhifs.com</p>
    </div>
  </motion.div>

  {/* Visit */}
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    className="flex items-center gap-4 p-8 text-left h-full"
  >
    <FaMapMarkerAlt className="text-[#70c037] text-3xl mt-1" />
    <div>
      <h3 className="font-semibold text-gray-800">Visit Us</h3>
      <p className="text-gray-600 leading-tight">
  Hyderabad,Telangana
</p>
    </div>
  </motion.div>

  {/* Hours */}
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    className="flex items-start gap-4 p-8 text-left"
  >
    <FaClock className="text-[#70c037] text-3xl mt-1" />
    <div>
      <h3 className="font-semibold text-gray-800">Working Hours</h3>
      <p className="text-gray-600">10:00 AM – 7:00 PM</p>
    </div>
  </motion.div>

</div>
  </div>

</section>

      {/* Contact Info Cards */}
      {/* <section className="py-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { title: 'Visit Us', lines: ['123 Finance Street', 'New York, NY 10001'] },
              { title: 'Call Us', lines: ['+1 (555) 123-4567', '+1 (555) 987-6543'] },
              { title: 'Email Us', lines: ['info@claritycorp.com', 'support@claritycorp.com'] },
              { title: 'Working Hours', lines: ['Mon - Fri: 9AM - 6PM', 'Sat: 10AM - 2PM'] },
            ].map((info, index) => (
              <motion.div
                key={info.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                data-testid={`contact-info-${index}`}
                className="bg-white rounded-xl p-6 shadow-sm text-center"
              >
                <h3 className="font-semibold text-gray-900 mb-2">
                  {info.title}
                </h3>
                {info.lines.map((line, i) => (
                  <p key={i} className="text-gray-500 text-sm">
                    {line}
                  </p>
                ))}
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Contact Form */}
<section className="py-16 bg-gray-50" style={{marginTop:"-40px"}}>

<motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
  
  <div className="max-w-3xl mx-auto px-6 text-center">

    {/* Heading with lines */}
    <div className="flex items-center justify-center gap-4 mb-10">
      <div className="h-[1px] bg-gray-300 w-24 sm:w-40"></div>

      <h2 className="text-3xl font-semibold text-gray-800 whitespace-nowrap">
        Get In Touch
      </h2>

      <div className="h-[1px] bg-gray-300 w-24 sm:w-40"></div>
    </div>


<form
  onSubmit={handleSubmit}
  className="space-y-5"
  data-testid="contact-form"
>

  {/* Row 1 → Name + Email */}
  <div className="grid sm:grid-cols-2 gap-5">
    <input
      type="text"
      name="name"
      value={formData.name}
      onChange={handleChange}
      placeholder="Your Name"
      className="w-full border border-gray-300 rounded-md px-4 py-3 shadow-md focus:outline-none focus:ring-2 focus:ring-[#70c037]"
    />

    <input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      placeholder="Your Email"
      className="w-full border border-gray-300 rounded-md px-4 py-3 shadow-md focus:outline-none focus:ring-2 focus:ring-[#70c037]"
    />
  </div>

  {/* Row 2 → Phone + Service */}
  <div className="grid sm:grid-cols-2 gap-5">
    <input
      type="tel"
      name="phone"
      value={formData.phone}
      onChange={handleChange}
      placeholder="Phone Number"
      className="w-full border border-gray-300 rounded-md px-4 py-3 shadow-md focus:outline-none focus:ring-2 focus:ring-[#70c037]"
    />

    <select
      name="service"
      value={formData.service}
      onChange={handleChange}
      className="w-full border border-gray-300 rounded-md px-4 py-3 shadow-md focus:outline-none focus:ring-2 focus:ring-[#70c037] bg-white"
    >
      <option value="">Select Service</option>
      <option value="insurance">Insurance</option>
      <option value="loans">Loans</option>
    </select>
  </div>

  {/* Message */}
  <textarea
    name="message"
    value={formData.message}
    onChange={handleChange}
    placeholder="Your Message"
    rows={5}
    className="w-full border border-gray-300 rounded-md px-4 py-3 shadow-md focus:outline-none focus:ring-2 focus:ring-[#70c037] resize-none"
  />

  {/* 🔐 CAPTCHA */}
  <div className="flex justify-center">
    <ReCAPTCHA
      sitekey="6LcLT44sAAAAAHdMQ21Eg51hiykMdRt0CVsYLkYB"   // 🔥 paste your site key here
      ref={captchaRef}
    />
  </div>

  {/* Button */}
  <div className="flex justify-center">
    <button
      type="submit"
      disabled={submitting}
      className="bg-green-700 hover:bg-green-800 text-white px-10 py-3 rounded-md font-medium transition shadow-md"
    >
      {submitting ? "Sending..." : "Send Message"}
    </button>
  </div>

</form>
  </div>
  </motion.section>
</section>

  {/* Google Map */}
<section className="py-16 bg-white">
  <motion.section
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <div className="max-w-6xl mx-auto px-6">

      {/* Heading */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-semibold text-gray-800">
          Our Location
        </h2>
        <p className="text-gray-500 mt-2">
          Find us easily on the map
        </p>
      </div>

      {/* Map */}
      <div className="rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.15)] border border-gray-200">
        <iframe
  title="Abhishek M Location"
  src="https://www.google.com/maps?q=Abhishek+M+Hyderabad&output=embed"
  width="100%"
  height="400"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
></iframe>
      </div>

    </div>
  </motion.section>
</section>


    </div>
    
  );
};

export default ContactPage;
